module.exports = __webpack_public_path__ + "img/sh2.8d55ab1c.png";